module.exports = __webpack_public_path__ + "img/import-3-en.5d2278ee.png";